import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-6 sm:mb-8" }
const _hoisted_2 = { class: "bg-gray-50 border border-gray-200 rounded-lg p-4 sm:p-6" }
const _hoisted_3 = { class: "flex items-start gap-3 sm:gap-4" }
const _hoisted_4 = { class: "flex-1 min-w-0" }
const _hoisted_5 = { class: "flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4" }
const _hoisted_6 = { class: "flex items-center gap-2 sm:gap-3 bg-white border border-gray-300 rounded-lg px-3 sm:px-4 py-2 sm:py-3 w-full sm:w-auto" }
const _hoisted_7 = { class: "font-mono text-sm sm:text-lg font-semibold text-black truncate" }

import { ActionButton } from '@/components'

interface Props {
  referralCode: string
}

interface Emits {
  (e: 'copy'): void
  (e: 'view-template'): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ReferralCodeSection',
  props: {
    referralCode: {}
  },
  emits: ["copy", "view-template"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit

const copyReferralCode = () => {
  emit('copy')
}

const viewTemplate = () => {
  emit('view-template')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex-shrink-0" }, [
          _createElementVNode("div", { class: "w-10 h-10 sm:w-12 sm:h-12 bg-blue-100 rounded-lg flex items-center justify-center" }, [
            _createElementVNode("i", { class: "fas fa-gift text-blue-600 text-lg sm:text-xl" })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "text-base sm:text-lg font-semibold text-black mb-2 leading-tight" }, " Votre code de parrainage Efashion -10% sur toutes les commandes passées chez vous à vie ", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-sm sm:text-base text-black mb-3 sm:mb-4 leading-relaxed" }, " À envoyer à tous vos clients et prospects et valable à vie si c'est la première fois qu'ils passent commande via Efashion* ", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-xs sm:text-sm text-black leading-relaxed" }, " *Si l'acheteur est déjà inscrit sur Efashion ou a déjà passé commande chez vous, le code n'est pas valable. Efashion ne prendra pas tout simplement pas de commission sur les commandes passées par vos acheteurs parrainés grâce au code. ", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fas fa-user text-black text-sm sm:text-base" }, null, -1)),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.referralCode), 1),
              _createElementVNode("button", {
                onClick: copyReferralCode,
                class: "p-1 sm:p-2 text-black hover:text-blue-600 transition-colors flex-shrink-0",
                title: "Copier le code"
              }, _cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "fas fa-copy text-sm sm:text-base" }, null, -1)
              ]))
            ]),
            _createVNode(_unref(ActionButton), {
              label: "Voir Template",
              icon: "fas fa-eye",
              variant: "secondary",
              onClick: viewTemplate,
              class: "w-full sm:w-auto"
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})